import React, { useCallback, useEffect, useState } from 'react';
import './SkipPqPrefillVariant.css';
import { cleanInternalLinkUrl } from '../../../utils/cob-utils';
import SessionStorage from '../../../utils/SessionStorage';
import { IPartnerOfferFormProps } from '../PartnerOfferForm';
import { CompareApi } from '../../../utils/compare-api/CompareApi';

interface ISkipPqPrefillVariantProps extends IPartnerOfferFormProps {

}

export const SkipPqPrefillVariant = (props: ISkipPqPrefillVariantProps) => {

    const [actionUrl, setActionUrl] = useState(cleanInternalLinkUrl(props.applicationPagePath + '.html'));
    const [adobeModeEngaged, setAdobeModeEngaged] = useState(false);

    useEffect(() => {
        SessionStorage.remove('offerId');
        SessionStorage.remove('pqOfOneAuthorizedUserShowing');
    }, []);

    const PrefillInput = useCallback(({ label, id }: { label: string, id: string }) => (
        <label>
            <span>{label}:</span>
            <input
                className='SkipPqPrefillVariant__input'
                type='text'
                name={id} />
        </label>
    ), []);

    const initAdobeMode = useCallback(() => CompareApi.initializeAcquisitionsAdobeModeApi().then(() => setAdobeModeEngaged(true)), []);

    return (
        <div className='PartnerOfferForm SkipPqPrefillVariant'>
            <label>
                <button onClick={initAdobeMode}>Initialise Adobe Mode</button>
                {adobeModeEngaged && '✅'}
            </label>
            <label>
                <span>Action Url: {props.applicationPagePath}</span> <br/>
                <label>Append to Url: <input className='SkipPqPrefillVariant__addendum' onChange={(event: React.ChangeEvent<HTMLInputElement>) => setActionUrl(props.applicationPagePath + '?' + event.target.value)} /></label>
            </label>
            <form id='partner-offer-form' action={actionUrl} method='POST'>
                <fieldset>
                    <legend>Personal Information</legend>
                    <PrefillInput label='First Name' id='fname'/>
                    <PrefillInput label='Middle Initial' id='mname'/>
                    <PrefillInput label='Last Name' id='lname'/>
                    <PrefillInput label='Phone Number' id='mobilePhone'/>
                </fieldset>
                <fieldset>
                    <legend>Mailing Address</legend>
                    <PrefillInput label='Address' id='address1'/>
                    <PrefillInput label='Apartment' id='apartment'/>
                    <PrefillInput label='City' id='city'/>
                    <PrefillInput label='State' id='state'/>
                    <PrefillInput label='ZIP Code' id='zipcode'/>
                </fieldset>
                <fieldset>
                    <legend>Home Address</legend>
                    <PrefillInput label='Address' id='homeaddress1'/>
                    <PrefillInput label='Apartment' id='homeapartment'/>
                    <PrefillInput label='City' id='homecity'/>
                    <PrefillInput label='State' id='homestate'/>
                    <PrefillInput label='ZIP Code' id='homezipcode'/>
                </fieldset>
                <input className='SkipPqPrefillVariant__submit' type='submit' value='Submit' />
            </form>
        </div>
    );
};